import { render, staticRenderFns } from "./Page5.vue?vue&type=template&id=80fd5a6e&scoped=true&"
import script from "./Page5.vue?vue&type=script&lang=ts&"
export * from "./Page5.vue?vue&type=script&lang=ts&"
import style0 from "./Page5.vue?vue&type=style&index=0&id=80fd5a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fd5a6e",
  null
  
)

export default component.exports